//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { combineReducers } from 'redux';

import ApproveForGalleriesReducer from '@uia/approve-for-galleries/approve-for-galleries-slice';
import RightsRequestReducer from '@uia/rights-request/rights-request-reducer';
import SelectedItemReducer from '@uia/selected-item/selected-item-reducer';
import UIAOpenReducer from '@uia/uia-modal/modal-slice';
import WorkflowReducer from '@uia/uia-workflow/uia-workflow-reducer';

export default combineReducers({
  workflow: WorkflowReducer,
  rightsRequest: RightsRequestReducer,
  approveForGalleries: ApproveForGalleriesReducer,
  selectedItem: SelectedItemReducer,
  modalState: UIAOpenReducer,
});
